import _classCallCheck from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { Turntable } from "../api";
import { BaseResource } from "@kgsport-cms/common";
import "../common";
/**
 * 转盘抽奖
 */
export var TurntableService = /*#__PURE__*/function (_BaseResource) {
  _inherits(TurntableService, _BaseResource);
  var _super = _createSuper(TurntableService);
  function TurntableService() {
    _classCallCheck(this, TurntableService);
    return _super.apply(this, arguments);
  }
  _createClass(TurntableService, [{
    key: "getActivityTurntable",
    value:
    // 查询转盘活动
    function getActivityTurntable(params) {
      return this.requester.get(Turntable.getActivityTurntable, {
        params
      });
    }
    // 转盘抽奖
  }, {
    key: "drawTurntable",
    value: function drawTurntable(params) {
      return this.requester.get(Turntable.drawTurntable, {
        params
      });
    }
    // 转盘活动优惠获奖明细
  }, {
    key: "getTurntableDetailList",
    value: function getTurntableDetailList(params) {
      return this.requester.get(Turntable.getTurntableDetailList, {
        params
      });
    }
    // 获取转盘奖品明细
  }, {
    key: "getTurntablePrize",
    value: function getTurntablePrize(params) {
      return this.requester.get(Turntable.getTurntablePrize, {
        params
      });
    }
  }]);
  return TurntableService;
}(BaseResource);